import AppliedFiltersModal from './AppliedFiltersModal';

export default AppliedFiltersModal;
